// extracted by mini-css-extract-plugin
export default {"title":"auto-qa-message_title__MSNaA"};